import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { GA_HEADER_SPECIFIC_LINK_ACTION } from '../../../../containers/home/domain/store/HomeStoreEn';
import { AuthUser } from '../../../../containers/login/view-model/contexts/auth-context/AuthContextV1';
import { enableDesktopBookingFlow } from '../../../helpers/LocaleHelpers';
import LanguageSelectorCmp from '../../../language-selector/view/components/LanguageSelectorCmp';
import { LinkLabel } from '../../../types/CommonVM';
import { LanguageSelectorEntity } from '../../domain/entities/HeaderContentEntity';
import { logoutHandler } from '../helpers/HeaderLogoutHelper';
import { countOfLiveOrder } from '../helpers/OrderHistoryLoadable';
import styles from '../styles/Header.module.scss';
import {
  ga_header_event_prefix,
  live_orders_text,
  logout_button,
} from '../vm/HeaderStore';

interface SecondaryLinksComponentProps {
  is_authenticated: boolean;
  order_history: unknown;
  onTrackHandler: () => void;
  set_user: (user: AuthUser | undefined) => void;
  set_is_authenticated: (value: boolean) => void;
  set_is_mobile_menu_open: (updater: (prev: boolean) => boolean) => void;
  support_link: LinkLabel;
  language_selector: LanguageSelectorEntity;
}

function SecondaryLinksComponent({
  is_authenticated,
  order_history,
  onTrackHandler,
  set_user,
  set_is_authenticated,
  set_is_mobile_menu_open,
  support_link,
  language_selector,
}: Readonly<SecondaryLinksComponentProps>): React.ReactElement {
  const router = useRouter();
  const enableDesktopBkf = enableDesktopBookingFlow(router.locale);
  const hasLiveOrders = countOfLiveOrder(order_history) > 0;

  return (
    <div className={styles['secondary-link-container']}>
      {is_authenticated && enableDesktopBkf ? (
        <div className={styles['menu-item-container']}>
          {hasLiveOrders ? (
            <button
              type="button"
              className={styles['live-orders']}
              onClick={onTrackHandler}
            >
              <span className={styles['dot']} />
              {live_orders_text}
            </button>
          ) : null}
          <button
            type="button"
            className={styles['logout']}
            onClick={(): void => {
              void logoutHandler(
                set_user,
                set_is_authenticated,
                set_is_mobile_menu_open,
              );
            }}
          >
            {logout_button}
          </button>
        </div>
      ) : (
        <Link
          href={support_link.link}
          className={styles['secondary-link']}
          onClick={(): void => {
            publishGa4Events(
              ga_header_event_prefix,
              GA_HEADER_SPECIFIC_LINK_ACTION,
              support_link.label,
            );
          }}
        >
          {support_link.label}
        </Link>
      )}
      {language_selector.locales.length > 0 ? (
        <LanguageSelectorCmp content={language_selector} />
      ) : null}
    </div>
  );
}

export default SecondaryLinksComponent;
